import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { local_ui_hint_shortcut_hide } from '@/state/ui/hint_shortcut/local_ui_hint_shortcut_hide';
import { IHintShortcutData } from '@shared/dto/hint_shortcuts/i_hint_shortcut_data';
import { motion } from 'framer-motion';
import { forwardRef, useMemo } from 'react';
import { ViewHintShortcutIcons } from './ViewHintShortcutIcons';

interface Props {
  hint_data: IHintShortcutData;
  should_animate_layout?: boolean;
}
export const ViewHintShortcut = forwardRef<HTMLDivElement, Props>(({ hint_data }, ref) => {
  let { key, data_rows, keys_have_same_animation_delay } = hint_data;

  const dispatch = use_dispatch();

  const { hints_shortcut_visible } = use_slice_ui(['hints_shortcut_visible']);

  const is_visible = useMemo(() => hints_shortcut_visible.includes(key), [hints_shortcut_visible, key]);

  /*
   * EVENTS
   */

  function on_mouse_enter() {
    if (!hints_shortcut_visible.includes(key)) return;

    dispatch(local_ui_hint_shortcut_hide(key));
  }

  /*
   * EFFECTS
   */

  /*
   * RENDERS
   */

  function render_hints() {
    return data_rows.map((item, index) => {
      let { mouse_data, keys } = item;

      return (
        <div key={`${item.text}_${index}`} id={`${item.text}_${index}`} className="gap-5 w-full flex items-center justify-between">
          <ViewHintShortcutIcons {...{ index, mouse_data, keys, keys_have_same_animation_delay }} />
          <span className="text-[12px] text-page-foreground">{item.text}</span>
        </div>
      );
    });
  }

  /*
   * HTML
   */

  return (
    <motion.div
      ref={ref}
      onMouseEnter={on_mouse_enter}
      layout={true}
      initial={{ opacity: 0, scale: 0.75 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.75 }}
      transition={{ duration: CONSTANTS_TIME__client.TIMEOUT_ANIMATION_HINT_SHORTCUT_HIDE / 1000, ease: 'easeInOut' }}
      className={`cursor-default bg-bar border border-bar-border rounded-lg px-2 py-2  flex flex-col gap-3 items-center justify-center 
        ${is_visible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}`}
    >
      {render_hints()}
    </motion.div>
  );
});
